/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Activity } from '../api/types/types';
import orderBy from 'lodash/orderBy';

export function sortActivitiesByCompletionAndDate(activities: Activity[]): Activity[] {
  return orderBy(
    activities,
    [(activity) => activity.status === 1, (activity) => new Date(activity.scheduleDate).getTime()],
    ['asc', 'desc'],
  );
}
